import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
        { label: "Projects",  href: "/#projects" },
    { label: "Skills",    href: "/#capabilities" },
    { label: "Contact",   href: "/#contact" },
  ];

  return (
    <nav className="bg-gray-900 text-white fixed w-full top-0 left-0 z-50 border-b border-gray-700">
      <div className="max-w-5xl mx-auto px-6 h-14 flex justify-between items-center">
        <a href="/" className="text-base font-semibold tracking-tight">
          Laurence Klein
        </a>

        {/* Desktop links */}
        <ul className="hidden md:flex items-center space-x-8">
          {links.map(({ label, href }) => (
            <li key={label}>
              <a href={href} className="text-sm text-gray-300 hover:text-white transition">
                {label}
              </a>
            </li>
          ))}
        </ul>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2 text-gray-300 hover:text-white"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <ul className="md:hidden bg-gray-800 px-6 pb-4 flex flex-col space-y-1 border-t border-gray-700">
          {links.map(({ label, href }) => (
            <li key={label}>
              <a
                href={href}
                className="block py-2 text-sm text-gray-300 hover:text-white transition"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
